import {
  ISelectorChooser,
  ISelectorOption,
} from "@/components/excel/schema/definiens/selector";

export function findSelectorOption(
  value: number,
  chooser?: ISelectorChooser
): ISelectorOption | undefined {
  const options = chooser?.options;
  if (options && options.length) {
    return options.find((it) => it.value === value);
  }
}
